import actionTypes from "../actions/action-types";
import isEqual from "lodash-es/isEqual";
import {set,get} from "../utils/dotutils";

const BoxReducer = (state = {}, action) => {
    const newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case actionTypes.SET_BOX_STATE:
            set(newState, action.boxid, {...get(newState, action.boxid), ...action.state});
            return newState;
        default:
            return newState;
    }
};

export default BoxReducer;